import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@root/environments/environment';
import { APIConstants } from '@shared/services';

@Injectable()
export class NoAuthorizationInterceptor implements HttpInterceptor {
  constructor() {}
  // Delete-member url will launch as external link(without login) so need to remove authorization
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes(
        `${environment.hostURL}${APIConstants.DELETE_MEMBER_ACCOUNT.REQUEST_OTP}`
      ) ||
      request.url.includes(
        `${environment.hostURL}${APIConstants.DELETE_MEMBER_ACCOUNT.VERIFY_OTP}`
      ) ||
      request.url.includes(
        `${environment.hostURL}${APIConstants.DELETE_MEMBER_ACCOUNT.DELETE_ACCOUNT}`
      ) ||
      request.url.includes(
        `${environment.hostURL}${APIConstants.MEMBER_REGISTRATION.CHECK_ELIGIBILITY}`
      ) ||
      request.url.includes(
        `${environment.hostURL}${APIConstants.MEMBER_REGISTRATION.PRE_REGISTER}`
      ) ||
      request.url.includes(
        `${environment.hostURL}${APIConstants.MEMBER_SERVICES.SEND_EMAIL}`
      )
    ) {
      request = request.clone({
        headers: request.headers
          .delete('Authorization')
          .delete('Authorization-SSO').delete('ProviderType'),
      });
    }
    return next.handle(request);
  }
}
